import PropTypes from "prop-types";
import React from "react";
import { backgroundColorProp } from "core-web/utils/proptypes/modules/styleProps";
import styled from "theme/libs/styled";
import { useTheme } from "emotion-theming";

const Wrapper = styled("div", {
    shouldForwardProp: (prop) => ["backgroundColor"].indexOf(prop) === -1,
})`
    width: 100%;
    height: 100%;
    background-color: ${({ backgroundColor }) => backgroundColor};
`;

const BackgroundColor = ({ color, children, ...rest }) => {
    const { colors } = useTheme();
    const useColor = colors[color] || colors.bg_grey;

    return (
        <Wrapper backgroundColor={useColor} {...rest}>
            {children}
        </Wrapper>
    );
};

BackgroundColor.propTypes = {
    children: PropTypes.node.isRequired,
    color: backgroundColorProp,
};

BackgroundColor.defaultProps = {
    color: "white",
};

export default BackgroundColor;
